// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import styles from '../../Canvas.module.css'
import type { Edge, Rect } from './types'

export type CropFrameOverlayEdge = Edge

const BAR_LENGTH = 30
const BAR_THICKNESS = 4

interface CropFrameOverlayProps {
    rect: Rect
    selected: boolean
    contentScale: number
    onSelect: (e: React.PointerEvent) => void
    onResizeStart: (edge: CropFrameOverlayEdge, e: React.PointerEvent) => void
    onDragStart: (e: React.PointerEvent) => void
    sizeText?: string
}

export function CropFrameOverlay(props: CropFrameOverlayProps): ReactElement {
    const {
        rect,
        selected,
        contentScale,
        onSelect,
        onResizeStart,
        onDragStart,
        sizeText,
    } = props

    const scale = 1 / (contentScale || 1)
    const barLength = BAR_LENGTH * scale
    const barThickness = BAR_THICKNESS * scale

    return (
        <div
            className={styles.frame + (selected ? ' ' + styles.frameSelected : '')}
            style={{ left: rect.x, top: rect.y, width: rect.w, height: rect.h }}
            onPointerDown={(e) => {
                e.stopPropagation()
                if (e.button === 0) onSelect(e)
            }}
        >
            {/* Drag surface inside the frame */}
            <div className={styles.frameDragSurface} onPointerDown={(e) => { e.stopPropagation(); onDragStart(e) }} />
            {/* Edge bars */}
            <div
                className={styles.frameBar + ' ' + styles.frameBarN}
                style={{ width: barLength, height: barThickness }}
                onPointerDown={(e) => { e.stopPropagation(); onResizeStart('n', e) }}
            />
            <div
                className={styles.frameBar + ' ' + styles.frameBarS}
                style={{ width: barLength, height: barThickness }}
                onPointerDown={(e) => { e.stopPropagation(); onResizeStart('s', e) }}
            />
            <div
                className={styles.frameBar + ' ' + styles.frameBarE}
                style={{ width: barThickness, height: barLength }}
                onPointerDown={(e) => { e.stopPropagation(); onResizeStart('e', e) }}
            />
            <div
                className={styles.frameBar + ' ' + styles.frameBarW}
                style={{ width: barThickness, height: barLength }}
                onPointerDown={(e) => { e.stopPropagation(); onResizeStart('w', e) }}
            />
            {sizeText && (
                <div
                    className={styles.frameSizeLabel}
                    style={{
                        transform: `scale(${scale})`,
                        transformOrigin: 'left top',
                        marginTop: 10 * scale
                    }}
                    data-canvas-ui="true"
                >{sizeText}</div>
            )}
        </div>
    )
}

